export default __webpack_public_path__ + "static/business_card-51118e90b8b2f3d72ee8ee79dc0b94c8.jpg";